import { render, staticRenderFns } from "./seleFiltration.vue?vue&type=template&id=b42c2f60&scoped=true"
import script from "./seleFiltration.vue?vue&type=script&lang=js"
export * from "./seleFiltration.vue?vue&type=script&lang=js"
import style0 from "./seleFiltration.vue?vue&type=style&index=0&id=b42c2f60&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b42c2f60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b42c2f60')) {
      api.createRecord('b42c2f60', component.options)
    } else {
      api.reload('b42c2f60', component.options)
    }
    module.hot.accept("./seleFiltration.vue?vue&type=template&id=b42c2f60&scoped=true", function () {
      api.rerender('b42c2f60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dollars/components/seleFiltration.vue"
export default component.exports